module.exports = __webpack_public_path__ + "img/receipt.e66c320e.svg";